import React from "react";
import { FiAlignJustify } from "react-icons/fi";
import { Link } from "react-router-dom";
import avatar from "assets/img/avatars/avatar4.png";

const Navbar = (props) => {
  const socialStorageString = localStorage.getItem("social-storage");
  const socialStorage = JSON.parse(socialStorageString || "{}");
  const { onOpenSidenav, brandText } = props;

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-nowrap items-center justify-between rounded-xl bg-[#0b14374d] p-2 pb-2.5 backdrop-blur-xl">
      <div className="ml-[6px] flex items-center gap-3 min-w-0 flex-shrink">
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden flex-shrink-0"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        <p className="shrink text-xl md:text-[33px] capitalize text-red-500 text-left min-w-0 line-clamp-2">
          <Link to="#" className="font-bold capitalize text-white opacity-86 block line-clamp-2 leading-normal py-0.5">
            {brandText}
          </Link>
        </p>
      </div>

      {/* <div className="hidden md:flex h-[61px] w-fit gap-3 items-center flex-shrink-0 px-2">
            <img
          className="h-10 w-10 rounded-full flex-shrink-0"
              src={avatar}
          alt="Profile"
            />
        <p className="text-sm font-medium text-white whitespace-nowrap">
          {socialStorage?.username || "Admin"}
        </p>
      </div> */}
    </nav>
  );
};

export default Navbar;
